export const TRACKING_GENERAL_EVENT = 'TRACKING_GENERAL_EVENT';
export const TRACKING_CALCULATION_EVENT = 'TRACKING_CALCULATION_EVENT';
export const TRACKING_MONITORING_EVENT = 'TRACKING_MONITORING_EVENT';
export const TRACKING_RESET_MONITORING_EVENT = 'TRACKING_RESET_MONITORING_EVENT';

const generalEvents = [1];
const calculationEvents = [2];
const monitoringEvents = [3, 4, 5, 6];

class SocketActions {
  constructor(store) {
    this.store = store;
    this.handleEventReceived = this.handleEventReceived.bind(this);
  }

  dispatch = (message) => this.store.dispatch(message);

  handleEventReceived = ({ payload }) => {
    const { tracking = {} } = this.store.getState();
    const { eventsList } = tracking;
    const payloadData = JSON.parse(payload);
    const eventTypeId = eventsList && eventsList[payloadData.EventId] ? eventsList[payloadData.EventId].TypeId : 1;
    if (calculationEvents.includes(eventTypeId)) {
      this.dispatch({ type: TRACKING_CALCULATION_EVENT, payload: payloadData });
      if (payloadData.LockState === 2) {
        setTimeout(
          () => {
            this.dispatch({ type: TRACKING_RESET_MONITORING_EVENT, payload: payloadData });
          },
          4000
        );
      }
    } else if (monitoringEvents.includes(eventTypeId)) {
      this.dispatch({ type: TRACKING_MONITORING_EVENT, payload: payloadData });
      if (payloadData.LockState === 2) {
        setTimeout(
          () => {
            this.dispatch({ type: TRACKING_RESET_MONITORING_EVENT, payload: payloadData });
          },
          4000
        );
      }
    } else {
      this.dispatch({ type: TRACKING_GENERAL_EVENT, payload: payloadData });
    }
  }; 
}

export default SocketActions;
